// src/Components/Common/toastHelper.js
import { toast } from 'react-toastify';

// Componenti SVG per i toast
const SuccessIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
);

const ErrorIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>
    </svg>
);

const InfoIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
    </svg>
);

const WarningIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
    </svg>
);

const LoadingIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="loading-spinner">
        <path d="M12 4V2A10 10 0 0 0 2 12h2a8 8 0 0 1 8-8z"/>
    </svg>
);

export const toastSuccess = (message) => {
    toast.success(
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <SuccessIcon />
            <span>{message}</span>
        </div>,
        {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
        }
    );
};

export const toastError = (message) => {
    toast.error(
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ErrorIcon />
            <span>{message}</span>
        </div>,
        {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
        }
    );
};

export const toastInfo = (message) => {
    toast.info(
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <InfoIcon />
            <span>{message}</span>
        </div>,
        {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
        }
    );
};

export const toastWarning = (message) => {
    toast.warning(
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <WarningIcon />
            <span>{message}</span>
        </div>,
        {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
        }
    );
};

export const toastLoading = (message) => {
    return toast.loading(
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <LoadingIcon />
            <span>{message}</span>
        </div>,
        {
            position: "top-right",
        }
    );
};

export const updateToast = (toastId, message, type = 'success') => {
    const icons = {
        success: <SuccessIcon />,
        error: <ErrorIcon />,
        info: <InfoIcon />,
        warning: <WarningIcon />
    };

    toast.update(toastId, {
        render: (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {icons[type]}
                <span>{message}</span>
            </div>
        ),
        type: type,
        isLoading: false,
        autoClose: type === 'success' ? 3000 : 5000,
        closeButton: true,
    });
};

export const dismissToast = (toastId) => {
    toast.dismiss(toastId);
};

export const dismissAllToasts = () => {
    toast.dismiss();
};